import { request, requestList, buildQuery, orgBase } from '@/api/http'
import type { AssetListItem, AssetDetail, ListAssetsParams, AiAnalysis } from '@/api/types'

export const assetsApi = {
  list(orgId: string, params?: ListAssetsParams): Promise<AssetListItem[]> {
    return requestList(`${orgBase(orgId)}/assets${buildQuery(params)}`)
  },
  get(orgId: string, id: string): Promise<AssetDetail> {
    return request(`${orgBase(orgId)}/assets/${id}`)
  },
  aiAnalysis(orgId: string, id: string): Promise<AiAnalysis> {
    return request(`${orgBase(orgId)}/assets/${id}/ai-analysis`)
  },
}
